module.exports = __webpack_public_path__ + "img/cta.3b46344a.jpg";